module.exports = __webpack_public_path__ + "static/media/rain.931c8ad9.svg";